import { render } from "./MarketSource.vue?vue&type=template&id=cd86ed7e&scoped=true"
import script from "./MarketSource.vue?vue&type=script&lang=js"
export * from "./MarketSource.vue?vue&type=script&lang=js"

import "./MarketSource.vue?vue&type=style&index=0&id=cd86ed7e&scoped=true&lang=css"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd86ed7e"]])

export default __exports__